import { useSelector } from "react-redux";
import { selectUserDb } from "../store/slices/session/sessionSelector";
import { selectSimulatedRole } from "../store/slices/app/appSelector";
import { components } from "../types/api";

type Role = components["schemas"]["Role"];

export const useUserRole = () => {
  const userDb = useSelector(selectUserDb);
  const simulatedRole = useSelector(selectSimulatedRole);
  const realRole = userDb?.role as Role | undefined;

  // Only a real ADMIN can preview the app as another role, so a simulated
  // role never grants more access than the account actually has.
  const isSimulating = realRole === "ADMIN" && Boolean(simulatedRole);
  const role = isSimulating ? (simulatedRole as Role) : realRole;

  const isAdmin = role === "ADMIN";
  const isPricing = role === "PRICING";
  const isAccount = role === "ACCOUNT";
  const isTechnician = role === "TECHNICIAN";
  const isClient = role === "CLIENT";
  const isStrategy = role === "STRATEGY";

  // Shared permission flags
  const canSeeEverything = isAdmin || isPricing || isStrategy;
  const canEditEverything = isAdmin || isPricing || isStrategy;

  // Acceso al módulo Control y al apartado Margin de las líneas:
  // visible/usable solo para ADMIN, STRATEGY, TECHNICIAN y PRICING.
  const canAccessControlAndMargin =
    isAdmin || isStrategy || isTechnician || isPricing;

  return {
    role,
    isAdmin,
    isPricing,
    isAccount,
    isTechnician,
    isClient,
    isStrategy,
    canSeeEverything,
    canEditEverything,
    canAccessControlAndMargin,
    userDb,
    realRole,
    isSimulating,
  };
};
